import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { TipoClassificacaoCadastroFilterPipe } from './tipo-classificacao-cadastro-filter.pipe';
import { TipoClassificacaoGrupoCadastroFilterPipe } from './tipo-classificacao-grupo-cadastro-filter.pipe';
import { TipoClassificacaoGrupoCadastroPipe } from './tipo-classificacao-grupo-cadastro.pipe';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        TipoClassificacaoCadastroFilterPipe,
        TipoClassificacaoGrupoCadastroFilterPipe,
        TipoClassificacaoGrupoCadastroPipe
    ],
    exports: [
        TipoClassificacaoCadastroFilterPipe,
        TipoClassificacaoGrupoCadastroFilterPipe,
        TipoClassificacaoGrupoCadastroPipe
    ],
    providers: [
        TipoClassificacaoCadastroFilterPipe,
        TipoClassificacaoGrupoCadastroFilterPipe,
        TipoClassificacaoGrupoCadastroPipe
    ]
})
export class TipoClassificacaoPipeModule { }
